import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';
import { string, func } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { ProBadge } from '@fiverr-private/badges';
import { formatDate } from '@fiverr-private/futile';
import { dateTimeFormat, DATETIME_ELEMENT_STYLES } from '@fiverr-private/localization';
import { getLinkToSellerPage, DOMAIN_SOURCES } from '@fiverr-private/variations_display';
import { Avatar } from '@fiverr-private/fit';
import { getContext } from '@fiverr-private/fiverr_context';
import { SELLER } from '../../propTypes/seller';
import { SELLER_LEVEL_BADGES } from './constants';
import './style.scss';

/**
 * @param {number | string} registeredAt
 */
export const formatSellerRegistrationDate = (registeredAt) => {
    const date = typeof registeredAt === 'number' ? new Date(registeredAt * 1000) : new Date(registeredAt);
    const DATE_FORMAT = { year: DATETIME_ELEMENT_STYLES.NUMERIC, day: false, month: false };

    return dateTimeFormat({
        value: date,
        options: {
            fallbackValue: formatDate(date, DATE_FORMAT),
            year: DATETIME_ELEMENT_STYLES.NUMERIC,
        },
    });
};

const SellerCard = ({ seller, className, onAvatarClick = noop }) => {
    const { profilePhoto, memberSince, username, sellerLevel, isPro } = seller;

    const formattedYear = memberSince && formatSellerRegistrationDate(memberSince);
    const Badge = isPro ? ProBadge : SELLER_LEVEL_BADGES[sellerLevel];

    const { pageCtxId } = getContext();
    const sellerLink = getLinkToSellerPage(username, {
        source: DOMAIN_SOURCES.LOGO_MAKER,
        refCtxId: pageCtxId,
        contextReferrer: DOMAIN_SOURCES.LOGO_MAKER,
    });

    return (
        <div className={classnames('seller-card', 'cf', className)}>
            <Avatar src={profilePhoto} className="seller-avatar" username={username} size={36} />
            <div className="seller-info">
                <span className="designed-by">
                    <I18n k="logo_maker_perseus.choose_variation.seller_card.designed_by" />
                    <a href={sellerLink} target="_blank" rel="noreferrer" onClick={onAvatarClick}>
                        {username}
                    </a>
                </span>
                <br />
                <span className="seller-additional-info">
                    {formattedYear && (
                        <>
                            <I18n k="logo_maker_perseus.choose_variation.seller_card.on_fiverr" />:{' '}
                            <b>{formattedYear}</b>
                        </>
                    )}
                    {Badge && <Badge />}
                </span>
            </div>
        </div>
    );
};

SellerCard.propTypes = {
    seller: SELLER,
    className: string,
    onAvatarClick: func,
};

export default SellerCard;
